import React from 'react';

import { useAuth } from '@components/utilComponents/AuthProvider';

import { yandexMetricaAuth } from './helpers';
import { useYandexMetricaInit } from './hooks';

/** Счётчик Метрики этого фронта. Экспортируется, потому что цели по событиям
 * чата CarrotQuest отправляются в тот же счётчик (см. `metricaGoals.ts`). */
export const METRICA_ID = '21803329';

export const YandexMetricaManager: React.FC = () => {
  const user = useAuth();

  const isInitialized = useYandexMetricaInit(METRICA_ID);

  React.useEffect(() => {
    if (isInitialized && user) {
      yandexMetricaAuth(METRICA_ID, user);
    }
  }, [isInitialized, user]);

  return '';
};
